module.exports = __webpack_public_path__ + "static/media/demo.27b10ea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/demo.png
// module id = 527
// module chunks = 0